(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-rugby/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-rugby/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_rugby = svs.themes.sport_rugby || {};

  svs.themes.sport_rugby.initStatusStart = function (data) {
    if (svs.themes.sport_rugby.isLive(data.status.id)) {
      if (data.status.id === 1) {
        return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
      }

      if (data.status.id === 2) {
        return '<div class="brick match-status brick-active f-condensed align-center">2:A</div>';
      }

      if (_.contains([19, 20, 21, 103, 104], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      }

      if (_.contains([14, 16, 17, 18, 102], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
    } else if (svs.themes.sport_rugby.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 33) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">STR</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_rugby.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);